import React from 'react';
import map_image from '../../assets/images/map.png';
import Headline from '../../partials/Headline';
import Text from '../../partials/Text';

const Contact = () => {
  return (
    <div className="page page-contact">
      <div className="container container_narrow">
        <Headline h={1}>
          Kontakt
        </Headline>
        <section className="contact">
          <div className="row">
            <div className="col">
              <div className="card">
                <a href="mailto:lucie@skokan.eu" className="link link-mail">
                  lucie@skokan.eu
                </a>
                <a href="callto:+420776425809" className="link link-phone">
                  (+420) 776 425 809
                </a>
              </div>
            </div>
            <div className="col"> 
              <div className="address">
                <p className="text">Lyčkovo náměstí 34</p>
                <p className="text">Praha 1</p>
                <p className="text">110 00</p>
              </div>  
            </div>
          </div>
          <div className="row">
            <div className="map-wrapper">
              <Text
                className="text_big"
              >
                Kde nás najdete:
              </Text>
              <div className="map">
                <img src={map_image} alt="map" className="map-image" /> 
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Contact;